import React, { Component } from 'react'; 
import {Row, Col, Button, Table} from 'react-bootstrap';
import _ from 'lodash';


export default class AuditorScreen extends Component {
  constructor(props){
    super(props)
    this.state={      
      toggle:true,
      toggleA:false,
      toggleI:true,
      toggleF:false,
      toggleG:false,
      audioPlay: false,
      sourceNode: null,
      currentTime: 0,
      audioContext: null,
    }
    this.copyData = [];
    this.isRating=false;
    this.isRatingYes=false;
    this.isNCReason1=false;
    this.isNCReason2=false;
    this.isNCReason3=false;
    this.isNCReason4=false;
    this.isNCReason5=false;
  }
  componentDidMount(){
    const{auditorJson} = this.props   
    this.createTemplate(auditorJson.templateValue.Parameters)    
    this.additionalFieldBody(auditorJson.templateValue.Additional)
    this.setupAudio()
  }
  componentWillMount(){
    var months = ["January","February","March","April","May","June","July","August","September","October","November","December"];
    var today = new Date(),
    date = today.getDate() +  '-' +  months[today.getMonth()] + '-' + today.getFullYear();
    //let time = today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();
    this.setState({date:date})
    if(_.has(this.props.auditorJson.templateValue.Readonly, "AgentResponse")){
      this.setState({isClicked:true, agentResponse:this.props.auditorJson.templateValue.Readonly.AgentResponse})
    }
    if(_.has(this.props.auditorJson.templateValue.Readonly, "AgentFeedback")){
      this.setState({haveFeedback:true, agentFeedback:this.props.auditorJson.templateValue.Readonly.AgentFeedback})
    }
    if(_.has(this.props.auditorJson.templateValue.Readonly, "FeedBackDate")){
      this.setState({haveFeedbackDate:true, feedbackDate:this.props.auditorJson.templateValue.Readonly.FeedBackDate})
    }
  }
  componentWillUnmount() {
    this.resetAudio();
  }
 
  
  createTemplate = (json) => {
    let templateObj = [];
    _.map(json, (obj, paramindex) => {
      _.map(obj.attributes, (val, index) => {
        _.map(val.questions, (next, questindex) => {
          _.map(next.Scoring, (tt, scoreindex) => {
            let tempTemplateObj = {};
            let isParamDisable = ((paramindex < index) || (index < questindex)) ? true : false;
            let isAttribDisable = (index < questindex) ? true : false;
            tempTemplateObj.key = 'K' + templateObj.length
            tempTemplateObj.Parameters = {};
            tempTemplateObj.Parameters.id = "Parameters";
            tempTemplateObj.Parameters.value = obj;
            tempTemplateObj.Parameters.disabled = isParamDisable;
            tempTemplateObj.Attributes = {};
            tempTemplateObj.Attributes.id = "Attributes";
            tempTemplateObj.Attributes.value = val;
            tempTemplateObj.Attributes.disabled = isAttribDisable;
            tempTemplateObj.Questions = {};
            tempTemplateObj.Questions.id = "Questions";
            tempTemplateObj.Questions.value = next;
            tempTemplateObj.Scoring = {};
            tempTemplateObj.Scoring.id = "Scoring";
            tempTemplateObj.Scoring.value = tt;
            templateObj.push(tempTemplateObj);
            if(tt.textRating === true){
              this.isRatingYes=true
            } else {
              this.isRating = true
            }
            if(tt.NCReason1 === true){
              this.isNCReason1=true
            } 
            if(tt.NCReason2 === true){
              this.isNCReason2=true
            } 
            if(tt.NCReason3 === true){
              this.isNCReason3=true
            } 
            if(tt.NCReason4 === true){
              this.isNCReason4=true
            } 
            if(tt.NCReason5 === true){
              this.isNCReason5=true
            } 
          });
        });
      });
    });
    this.setState({ templateObj});
  }
  renderDocument(fieldValue){
    if(!_.isEmpty(fieldValue)){
      let firstObject=[]; let secondObject=[]; let thirdObject=[]; let fourthObject=[];
     // let n = fieldValue.length;
      _.map(fieldValue, (obj, i)=>{  
        (i < 4)  ?
          firstObject.push(<p><b>{obj.label}</b><br/><span className='colorBlue'>{obj.value}</span></p>) : (i <8 ) ?
          secondObject.push(<p><b>{obj.label}</b><br/><span className='colorBlue'>{obj.value}</span></p>) : (i < 12) ?
          thirdObject.push(<p><b>{obj.label}</b><br/><span className='colorBlue'>{obj.value}</span></p>)  : 
          fourthObject.push(<p><b>{obj.label}</b><br/><span className='colorBlue'>{obj.value}</span></p>)     
        })
        
       let returnObj = (   
          <Row className='information'>
          <Col>{firstObject}</Col>
          <Col>{secondObject}</Col>
          <Col>{thirdObject}</Col>
          <Col>{fourthObject}</Col>
          </Row>)
      return returnObj
       }
  }
  renderBody = () =>{
    
    const {templateObj} = this.state;  
    if(templateObj && templateObj.length > 0) {
      return _.map(templateObj, (row, rowIndex) => {
        let Scores = row.Scoring.value
        let Selected;
        if(_.has(this.props.auditorJson.templateValue, 'Readonly')){
          Selected = this.props.auditorJson.templateValue.Readonly.Scores[rowIndex];
        }
        
        return (
          <tr className='' key={row.key}>
            <td>{row.Parameters.value.label}</td>
            <td>{row.Attributes.value.label === 'null' ? '' : row.Attributes.value.label}</td>
            <td>{row.Questions.value.label === 'null' ? '' : row.Questions.value.label}</td>
            
              <td>
              <label><center>{Scores.weight}</center></label> </td>
              <td>
              {((Scores.NA)) ?<label>{Selected.NA ? 'Yes' : "No"}</label> : ''}  </td>            
              {this.isRatingYes  ?  <td>
              {(Scores.textRating && !_.isEmpty(Selected) && !(Selected.NA)) ? 
              <label>{ !_.isEmpty(Selected) ?  Selected.textrating : ""}</label>
              :''}</td> : null}
              {this.isRating  ?
              <td>              
              {!_.isEmpty(Selected) && (!(Selected.NA)) ? 
                <label>{ Selected.rating }</label> 
               :''}
              </td> : null}
              <td> {(Scores.Fatal && !_.isEmpty(Selected)) ? <label>{Selected.Fatal ? 'Yes' : "No"}</label> :'' }</td>
              {this.isNCReason1 ?  <td>{(Scores.NCReason1) ? <label>{!_.isEmpty(Selected) ? Selected.NCReason1 : ""}</label> : '' }</td>  : null}
              {this.isNCReason2 ?   <td>{(Scores.NCReason2) ? <label>{!_.isEmpty(Selected) ? Selected.NCReason2 : ""}</label> : '' }</td>: null}              
              {this.isNCReason3 ?  <td>{(Scores.NCReason3) ? <label>{!_.isEmpty(Selected) ? Selected.NCReason3 : ""}</label> : '' }</td> : null}
              {this.isNCReason4 ?  <td>{(Scores.NCReason4) ? <label>{!_.isEmpty(Selected) ? Selected.NCReason4 : ""}</label> : '' }</td> : null}
              {this.isNCReason5 ?  <td>{(Scores.NCReason5) ? <label>{!_.isEmpty(Selected) ? Selected.NCReason5 : ""}</label> : '' }</td> : null}
              <td><label>{!_.isEmpty(Selected)  ? Selected.feedback : ""}</label></td>
            
           
          </tr>
        )
      });
    }
    return (
      <tr className=""><td colSpan="5">No Records found.</td></tr>
    );

  }

  additionalFieldBody = (Additional) => {
    let DropDownObj=[], TextBoxObj=[], TextareaObj=[]
    if(!_.isEmpty(Additional)){ 
             _.map(Additional, (data, index)=>{
              if(data.label === 'Drop Down'){
                DropDownObj.push (<div className='additionalInfo'>
                   <b>{data.labelObj}</b>
                    { _.map(data.selected, (obj) => {
                      return(<label>{obj.label+ ',' }</label>)
                    }) }
                  </div>)
             }
              else if(data.label === 'Text Box'){
                TextBoxObj.push( <div className='additionalInfo'>
                <b> {data.labelObj}</b>
                <label>{data.textBoxValues}</label></div>)
              }
              else if(data.label === 'Text Area'){
                TextareaObj.push(  <div className='additionalInfo'>
                <b>{data.labelObj}</b>
                <label>{data.textAreaValues}</label></div>)
              }
             
            })
 
    let returnVal  = (<div><Row>{DropDownObj}</Row><Row>{TextBoxObj}</Row><Row>{TextareaObj}</Row></div>)
    this.setState({additionalField:returnVal})
   }
   
  }

  // playRecord = () =>{     
  //   let url = this.props.auditorJson.templateValue.VoiceFeedback
  //   if(!_.isEmpty(url)){  
  //     const x = new Audio()
  //      x.src = url
  //      x.play()
  //   }
  // }
  
  resetAudio = () => {
    // Stop and release the previous audio source node
    if (this.state.sourceNode && this.state.sourceNode.context.state === 'running') {
      this.state.sourceNode.stop();
      this.state.sourceNode.disconnect();
    }

    // Close the previous audio context
    if (this.state.audioContext) {
      this.state.audioContext.close();
    }
  };
  setupAudio = () => {
    let url = this.props.auditorJson.templateValue.VoiceFeedback;
    if (!_.isEmpty(url)) {
      this.resetAudio(); // Reset previous audio before setting up the new audio

      const audioContext = new (window.AudioContext || window.webkitAudioContext)();

      // Convert base64-encoded audio data to ArrayBuffer
      const base64Data = url.split(",")[1];
      const binaryString = window.atob(base64Data);
      const byteArray = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        byteArray[i] = binaryString.charCodeAt(i);
      }
      const audioBuffer = byteArray.buffer;

      audioContext.decodeAudioData(audioBuffer, (buffer) => {
        this.setState({ buffer, audioContext });
      });
    }
  };
  playStart = () => {
    const { sourceNode, currentTime, audioContext } = this.state;
    this.setState({ audioPlay: true });

    // Create a new AudioBufferSourceNode for each play
    const newSourceNode = audioContext.createBufferSource();
    newSourceNode.buffer = this.state.buffer;
    newSourceNode.connect(audioContext.destination);
    newSourceNode.onended = () => {
      this.setState({ audioPlay: false });
    };

    // Store the new source node in the state
    this.setState({ sourceNode: newSourceNode });

    // Start playing from the last paused time
    newSourceNode.start(0, currentTime);
  };
  playPause = () => {
    this.setState({ audioPlay: false, currentTime: this.getCurrentTime() });
    
    // Stop and disconnect the current source node if it's playing
    if (this.state.sourceNode && this.state.sourceNode.context.state === 'running') {
      this.state.sourceNode.stop();
      this.state.sourceNode.disconnect();
    }
  };
  getCurrentTime = () => {
    const audioContext = this.state.sourceNode.context;
    return audioContext.currentTime - this.state.sourceNode.context.currentTime;
  };
  

  Accpetance = (prop) => {
    this.setState({agentResponse:prop})
  }
  // Rejectance = () => {
  //   this.setState({agentResponse:"Rejected", isClicked:true})
  // }
  handleFeedback = (e) =>{
    this.setState({agentFeedback:e.target.value})
  } 
  
  onSubmit = () => {
    const {agentResponse, agentFeedback, date} = this.state
    this.props.auditorJson.templateValue.Readonly['AgentResponse'] = agentResponse
    this.props.auditorJson.templateValue.Readonly['AgentFeedback'] = agentFeedback
    this.props.auditorJson.templateValue.Readonly['FeedBackDate'] = date
    this.props.closeModal()
    this.props.action.TokenValidation()      
    this.props.action.agentEvaluationSubmit(this.props.auditorJson, this.props.id)
  }
  handleAssesment = () =>{
    this.setState((prevState) =>{
      return {toggle: !prevState.toggle};
    })
  }
  handleAdditional = () =>{
    this.setState((prevState) =>{
      return {toggleA: !prevState.toggleA};
    })
  }
  handleFeedbackToggle = () =>{
    this.setState((prevState) =>{
      return {toggleF: !prevState.toggleF};
    })
  }
  handleFeedbackAgentToggle = () =>{
    this.setState((prevState) =>{
      return {toggleG: !prevState.toggleG};
    })
  }
  handleInformation = () =>{
    this.setState((prevState) =>{
      return {toggleI: !prevState.toggleI};
    })
  }

  handleScoreCalculation = () =>{
    this.setState((prevState) =>{
      return {toggleS: !prevState.toggleS};
    })
  }
  ScoreCalculation = (data) => {
    let returnObj = [];
       _.map(data.scoreCalculation, (obj, t) => {        
          let paramfinal = 0;
          let final =1; 
          _.map(obj.qualityAttrList, (tt, i) =>{           
             paramfinal = paramfinal+(tt.scoreAttributes).length           
          })
         _.map(obj.qualityAttrList, (tt, i) =>{        
          final = tt.scoreAttributes.length 
          _.map(tt.scoreAttributes, (zz, index) =>{ 
          let className=""
          if(index <=  _.findLastIndex(tt.scoreAttributes)){
            if(t % 2 === 0){
              className='colorEven'
            } else{
              className='colorOdd'
            }          
          }   
          returnObj.push(
             <tr className={className} > 
               <td>{obj.qualityParam}</td>
               <td>{tt.qualityAttribute}</td>
               <td>{zz.qualityParam}</td>
               <td>{zz.maxScore}</td>
               <td>{zz.actualScore}</td>
               <td>{zz.paramScore}</td>    
               {index === 0 ? <td rowspan={final} className='NoVertical'>{tt.attScore}</td> : null}
               {(index === 0 && i === 0) ? <td rowspan={paramfinal} className='NoVertical'>{obj.parameterScore}</td> : null}
             </tr>)
         })
         })       
      }) 
    returnObj.push(<tr><td></td><td></td><th>Overall Score </th><th>{data.overallMaxScore}</th>
      <th>{data.overallActualScore}</th><th colspan="3">{data.overallAttributeScore}</th>      
      </tr>)
    returnObj.push(<tr><td></td><td></td><th>Overall Score Without Fatal</th><th>{data.maxScoreFatal}</th>
      <th>{data.actualScoreFatal}</th><th colspan="3">{data.overallScoreFatal}</th>      
      </tr>) 
     return returnObj
  }
  validateForm = () =>{    
    const {agentResponse, agentFeedback} = this.state;
      if(!_.isEmpty(agentResponse) &&  !_.isEmpty(agentFeedback)){
        return true }
  }
 
  
  render(){
    const{toggle, toggleA, toggleF, toggleI, additionalField, toggleS, toggleG, isClicked, haveFeedbackDate}= this.state;
    const{ CompletedAuditsView, auditorJson } = this.props

    return(
      <div>  
        <h6 className={toggleI ? 'evalFormMargin': 'evalForm'} onClick={this.handleInformation} >
        {toggleI ? <i class="fas fa-caret-down"/> : <i class="fas fa-caret-right"/>} <b>INFORMATION </b></h6>  
        <div className={toggleI ? 'assesmentShow': 'assesmentHide'}>            
        {this.renderDocument(this.props.fieldValue)}  </div>
        <h6 className={toggle ? 'evalFormMargin': 'evalForm'} onClick={this.handleAssesment}>
        {toggle ? <i class="fas fa-caret-down"/> : <i class="fas fa-caret-right"/>} <b>ASSESMENT</b></h6>        
        <div className={toggle ? 'assesmentShow': 'assesmentHide'}>           
         <Table responsive className='readOnly'>        
          <thead>
            <tr className='Assesment'>
            <th>Parameters</th>
              <th>Attributes</th>
              <th>Questions</th>
              <th>Wtg.</th>
              <th>NA</th>
              {this.isRatingYes  ?  <th>Rating<br/>(Y/N)</th> : null}
              {this.isRating  ?   <th>Rating</th> : null}
              <th>Fatal</th>
              {this.isNCReason1 ?<th style={{'width':'100px'}}>NCReason 1</th> : null}
              {this.isNCReason2 ?<th style={{'width':'100px'}}>NCReason 2</th> : null}
              {this.isNCReason3 ?<th style={{'width':'100px'}}>NCReason 3</th> : null}
              {this.isNCReason4 ?<th style={{'width':'100px'}}>NCReason 4</th> : null}
              {this.isNCReason5 ?<th style={{'width':'100px'}}>NCReason 5</th> : null}
              <th style={{'width':'100px'}}>Feedback</th>
              </tr>
          </thead>
          <tbody>
            {
              this.renderBody()
            }
        </tbody>
        </Table>
        </div>
        {(!_.isEmpty(additionalField)) ?
        <div>
        <h6 className={toggleA ? 'evalFormMargin': 'evalForm'} onClick={this.handleAdditional}>{toggleA ? <i class="fas fa-caret-down"/> :
         <i class="fas fa-caret-right"/>}  <b>ADDITIONAL INFORMATION</b></h6> 
        <div className={toggleA ? 'assesmentShow': 'assesmentHide'}>
        {this.state.additionalField} </div></div> : null}
        {(!_.isEmpty(this.props.ScoreCalculation) && typeof this.props.ScoreCalculation !== 'undefined') ? 
        <div>       
        <h6 className={toggleS ? 'evalFormMargin': 'evalForm'} onClick={this.handleScoreCalculation}>
        {toggleS ? <i class="fas fa-caret-down"/> : <i class="fas fa-caret-right"/>}  <b>SCORE CALCULATION</b></h6> 
        <div className={toggleS ? 'assesmentShow': 'assesmentHide'}>
          <Table responsive className='noalternate'>
            <thead>
              <th>PARAMETERS</th><th>ATTRIBUTES</th><th>QUESTIONS</th><th>MAX SCORE</th>
              <th>ACTUAL SCORE</th><th>QUESTION SCORE (in %)</th><th>ATTRIBUTE SCORE (in %)</th>
              <th>PARAMETER SCORE (in %)</th>
            </thead>
            <tbody>
              {this.ScoreCalculation(this.props.ScoreCalculation)}
            </tbody>
          </Table>
        </div> 
        </div>
        : null }   
        <h6 className={toggleF ? 'evalFormMargin': 'evalForm'} onClick={this.handleFeedbackToggle}>{toggleF ?
        <i class="fas fa-caret-down"/> : <i class="fas fa-caret-right"/>} <b>FEEDBACK-QA</b></h6> 
        <div className={toggleF ? 'assesmentShow': 'assesmentHide'}>
          <Row className='auditor_Feedback'>
        <Col>
        <b>Auditor's Feedback</b><br/>
        <label>{_.has(auditorJson.templateValue, "Readonly") ? auditorJson.templateValue.Readonly.FinalFeedback
        : ""}</label><br/>
        {(auditorJson.templateValue.VoiceFeedback)?
        <>
        <b>	Voice Feedback </b> 
        {this.state.audioPlay ? (
          <>
          <i className="fas fa-stop" onClick={this.playPause}></i>
          <div className="wav_center">
            <div class="wave"></div>
            <div class="wave"></div>
            <div class="wave"></div>
            <div class="wave"></div>
            <div class="wave"></div>
            <div class="wave"></div>
            <div class="wave"></div>
            <div class="wave"></div>
            <div class="wave"></div>
            <div class="wave"></div>
          </div>
          </>
        ) : (
          <i className="fas fa-play" onClick={this.playStart}></i>
        )}
        <br/>  
        </> :null}  
        </Col>
        <Col>          
          <b> QA Name </b> <br/> <label>{_.has(auditorJson.templateValue, "Readonly") ? auditorJson.templateValue.Readonly.QAName
        : ""}</label><br/>  
        <b> Evaluated Date </b><br/><label>{_.has(auditorJson.templateValue, "Readonly") ? auditorJson.templateValue.Readonly.EvaluationDate
        : ""}</label>      
        </Col>
        </Row>       
        </div>


        {((this.state.haveFeedback === true) || (CompletedAuditsView === true))   ?
        <div>
        <h6 className={toggleG ? 'evalFormMargin': 'evalForm'} onClick={this.handleFeedbackAgentToggle}>{toggleG ?
        <i class="fas fa-caret-down"/> : <i class="fas fa-caret-right"/>} <b>FEEDBACK-Agent</b></h6> 
        <div className={toggleG ? 'assesmentShow': 'assesmentHide'}>
          <Row className='auditor_Feedback'>
          <Col md={3}>         
          <span><b>Agent Feedback<span className="RedColoring">*</span></b></span><br/>
          {(this.state.haveFeedback === true) ? <span>{this.state.agentFeedback}<br/></span> :
          <textArea  style={{'width':'80%'}} value={this.state.agentFeedback} onChange={this.handleFeedback}/>}
          </Col><Col>
           <b> Feedback Date </b><br/> {(haveFeedbackDate === true ) ? this.state.feedbackDate : this.state.date}         
        </Col>
        <Col md={3}>        
            <div>
            <b>Feedback to review<span className="RedColoring"> *</span></b><br/>
            {(isClicked === true )  ?     this.state.agentResponse :
              <div>
              <label><b>Accept  </b><input type='radio' checked={this.state.agentResponse === 'Accept' ? true : false}  onClick={()=>this.Accpetance('Accept')} /></label>
              <label><b>&nbsp;Deny </b><input type='radio' checked={this.state.agentResponse === 'Deny' ? true : false}    onClick={()=>this.Accpetance('Deny')} /></label>
              {/* <i class="fas fa-check" onClick={this.Accpetance}/> &nbsp;
              <i class="fas fa-times" onClick={this.Rejectance} /> */}
            </div>} 
        </div>
        </Col>
        <Col>
        { (this.state.haveFeedback === true) ? null :
         <Button className='buttonwidth' disabled={!this.validateForm()} onClick={this.onSubmit}>Submit</Button> 
        }
        </Col>        
          </Row>       
        </div>
        </div> : null}
      
      </div>
     // </div>
    )
  }
}